import { render, staticRenderFns } from "./PhraseSearchResult.vue?vue&type=template&id=d16448ce&scoped=true"
import script from "./PhraseSearchResult.vue?vue&type=script&lang=js"
export * from "./PhraseSearchResult.vue?vue&type=script&lang=js"
import style0 from "./PhraseSearchResult.vue?vue&type=style&index=0&id=d16448ce&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16448ce",
  null
  
)

export default component.exports